import React from 'react';
import { observer } from 'mobx-react';
import { BASE_URL_NAME } from '../../utils/constants';
import DayKarKalLayout from './CompanyLayout/DayKarKalLayout';
import MilwaysLayout from './CompanyLayout/MilwaysLayout';
import ProjectSearchBox from '../ProjectSearchBox';

const NotFoundPage = observer(() => {
  const Layout = BASE_URL_NAME === 'Milways' ? MilwaysLayout : DayKarKalLayout;

  return (
    <Layout>
      <ProjectSearchBox />
    </Layout>
  );
});

export default NotFoundPage;
